<template>
  <Head>
    <Title>Služby a ceny - Ludmila Zacharová</Title>
  </Head>
  <siteblocks-navmenu />
  <v-container>
    <v-sheet class="mx-4">
      <h1>Služby a ceny</h1>
    </v-sheet>
    <v-row>
      <v-col cols="12" md="6">
        <siteblocks-offer image="/nature.jpg" title="Focení v přírodě" link="/priroda">
          Focení v přírodě je nejlepší způsob, jak spojit krásu přírody s krásou Vašich citů a emocí.
          Navrhnu Vám hezké místo pro focení, pomohu s výběrem oblečení, které bude na fotografiích vypadat
          harmonicky a zároveň bude pohodlné a příjemné. Nezmeškejte příležitost mít fotografie, které Vám
          budou dělat radost celý život!
          <br><br>
          <li> Balíček 10 fotografií - 3 000 Kč a zahrnuje 10 umělecky upravených fotografií. </li>
          <li> Balíček 20 fotografií - 5 000 Kč a zahrnuje 20 umělecky upravených fotografií. </li>
          <li>Každá další umělecky upravená fotografie je za 300 Kč.</li>
          <li>Po focení Vám zašlu fotografie k výběru těch, které si přejete nechat umělecky upravit.</li>
          <br></br>
          <b>Bonus +5 fotografií</b><br>
          Ke každému balíčku získáte 5 fotografií navíc zdarma, pokud souhlasíte s použitím Vašich fotografií
          pro prezentaci mé práce na těchto webových stránkách a sociálních sítích.
        </siteblocks-offer>
      </v-col>

      <v-col cols="12" md="6">
        <siteblocks-offer image="/newborn.jpg" title="Focení novorozenců v klasickém stylu." link="/newborn">
          Focení novorozenců v klasickém stylu doporučuji do 10 dnů od narození miminka.
          V tomto věku dítě většinou spí, což umožňuje vytvořit roztomilé fotografie.
          Poskytují vhodné oblečení pro miminko a různé doplňky. Společné fotky rodičů s novorozencem fotím na studiovém pozadí.
          Focení může probíhat u Vás doma (vše potřebné přivezu s sebou), anebo u mě v domácím ateliéru.
          <br><br>
          <li> Balíček 10 fotografií - 3 000 Kč a zahrnuje 10 umělecky upravených fotografií. </li>
          <li> Balíček 20 fotografií - 5 000 Kč a zahrnuje 20 umělecky upravených fotografií. </li>
          <li>Každá další umělecky upravená fotografie je za 300 Kč.</li>
          <li>Po focení Vám zašlu fotografie k výběru těch, které si přejete nechat umělecky upravit.</li>
          <br></br>
          <b>Bonus +5 fotografií</b><br>
          Ke každému balíčku získáte 5 fotografií navíc zdarma, pokud souhlasíte s použitím Vašich fotografií
          pro prezentaci mé práce na těchto webových stránkách a sociálních sítích.
        </siteblocks-offer>
      </v-col>
    </v-row>
    <v-row>

      <v-col cols="12" md="6">
        <siteblocks-offer image="/valentine.jpg" title="Valentine" link="/valentine">
          Srdečně vás zvu na párové focení „Valentine“!
          Je to jedinečná příležitost zastavit se, prožít společné chvíle a připomenout si, jak moc jste si navzájem důležití.
          <br><br>
          Kde focení probíhá?
          <li>V mém domácím ateliéru s profesionálním fotozařízením.</li>
          <li>Nebo přímo u vás doma – přivezu potřebné vybavení a vytvořím kouzlo ve vašem prostoru.</li>
          <br><br>
          <li>Cena ve všední dny je 2000 Kč za 5 fotografií. O víkendech je příplatek 500 Kč.</li>
          <li>Každá další upravená fotografie je za 300 Kč.</li>
          <li>Atelier u vás doma: příplatek 500 Kč.</li>
          <li>Hotové fotografie obdržíte do týdne od výběru fotografií k úpravě. Náhledy k výběru zasílám do 3 dnů po focení.</li>
          <br><br>
        </siteblocks-offer>
      </v-col>

      <v-col cols="12" md="6">
        <siteblocks-offer image="/lifestyle.jpg" title="Focení lifestyle - jeden den vašeho života!" link="/lifestyle">
          Váš domov, Vaše pohoda, Váš život. Krásně zachytím to, co rádi děláte, s dětmi i bez nich!
          Čtení knih, malování, Vaši kuchyň, pletení, Vaši zahradu, to, jak si děti hrají, jejich oblíbené aktivity a hračky,
          Vaše domácí mazlíčky - vyfotím cokoliv budete chtít. Naplánujeme vše, co byste chtěli zachytit v tom nejkrásnějším
          a nejpřirozenějším provedení!
          <br><br>
          <li> Focení je 4000 Kč, obdržíte 50 až 100 fotografií. </li>
        </siteblocks-offer>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <siteblocks-offer image="/vanoce.jpg" title="Vánoční focení" link="/vanoce">
          Srdečně vás zvu na vánoční focení! Každý rok připravuji ve svém domácím ateliéru útulné dekorace,
          díky kterým vytvořím krásné a jedinečné fotografie, které zachytí kouzlo Vánoc. 🎄📸
          <br><br>
          Díky tomu, že fotím v domácím ateliéru, snadno si domluvíme termín, který bude vyhovovat všem.
          A také není třeba spěchat, focení probíhá v klidné a pohodové atmosféře.
          <br><br>
          <li>Cena ve všední dny je 3000 Kč za 10 fotografií. O víkendech je příplatek 500 Kč.</li>
          <li>Každá další upravená fotografie je za 300 Kč.</li>
          <li>Hotové fotografie obdržíte do týdne od výběru fotografií k úpravě. Náhledy k výběru zasílám do 3 dnů po focení.</li>
          <br><br>
        </siteblocks-offer>
      </v-col>
    </v-row>
  </v-container>
</template>